<!-- =========================================================================================
	File Name: ItemGridView.vue
	Description: Item Component - Grid VIew
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <!-- <div class="item-grid-view vx-row match-height">
      <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID"> -->
  <vx-card class="grid-view-item mb-base overflow-hidden">
    <template slot="no-body">
      <vs-avatar v-if="item.combo" color="danger" icon-pack="feather" icon="icon-gift" size="50px" style="position: absolute; top: 5px; right: 10px;"/>
      <vs-avatar v-if="item.stockControl" :color="itemOnHand > 0 ? 'success' : 'danger'" size="large" :text="itemOnHand.toString()" style="position: absolute; top: 5px; right: 10px;"/>

      <!-- ITEM IMAGE -->
      <div class="item-img-container bg-white h-48 flex items-center justify-center mb-4">
        <vx-tooltip position="left" :title="item.name" :text="item.description">
          <img :src="getImage(item)" :alt="item.name" class="grid-view-img px-4" @click="addToCart(item)">
        </vx-tooltip>
      </div>
      <div class="flex flex-wrap justify-between">
        <div class="item-details px-4 max-w-xs">

          <!-- RATING & PRICE -->
          <div class="flex justify-between items-center">
            <span class="text-sm mr-2 truncate">{{ item.code }} / {{ item.categoryName }}</span>
            <!--            <h6 class="font-bold">&nbsp;</h6>-->
          </div>

          <!-- TITLE & DESCRIPTION -->
          <div class="my-3">
            <h6 class="truncate mb-1">{{ item.name }}</h6>
          </div>
        </div>
        <span v-show="false">{{ itemOnHand }}</span>
      </div>

      <!-- SLOT: ACTION BUTTONS -->
      <slot name="action-buttons"/>
    </template>
  </vx-card>
  <!--  </div>
</div> -->
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')


  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        onHand: 0,
        stockLoaded: false
      }
    },
    computed: {
      itemOnHand() {
        return this.$store.getters.getStock({warehouseId: 1, productId: this.item.id}).onHand;
      }
    },
    methods: {
      getImage(product) {
        var image = '';
        if (product.hasOwnProperty('smallImage')) {
          image = product.smallImage == '' ? product.image : product.smallImage;
        } else {
          if (product.hasOwnProperty('image')) {
            image = product.image;
          }
        }
        if (image == '' && !product.noImage && product.hasImage) {
          var data = {
            id: parseInt(product.id),
            userId: this.$store.state.AppActiveUser.userId,
            token: this.$store.state.AppActiveUser.token
          };
          this.$http.post(deltaPOS_config.default.apiURL + '/products/small_image', data).then(response => {
            if (response.data.success) {
              var newImage = response.data.data.smallImage == '' ? response.data.data.image : response.data.data.smallImage;
              if (newImage == '') {
                this.$store.dispatch("updateProductImage", {id: product.id, noImage: true, image: ''});
              } else {
                this.$store.dispatch("updateProductImage", {id: product.id, noImage: false, image: newImage});
                image = newImage;
              }
            }
          });
        }
        return `data:image/jpeg;base64,${image}`;
      },
      getStock(product) {
        var stock = this.onHand;
        var self = this;
        var data = {
          productId: parseInt(product.id),
          warehouseId: self.sessionData.warehouseId,
          userId: self.$store.state.AppActiveUser.userId,
          token: self.$store.state.AppActiveUser.token
        };
        //this.$store.dispatch("updateProductOnHand", {id: product.id, onHand: stock});
        this.$http.post(deltaPOS_config.default.apiURL + '/stock/on_hand/product', data).then(response => {
          if (response.data.success) {
            if (response.data.data.onHand) {
              product.onHand = response.data.data.onHand;
              // this.$store.dispatch("updateProductImage", {id: product.id, noImage: true, image: ''});
            }
          }
          self.stockLoaded = true;
        });
        return stock;
      },
      addToCart(item) {
        this.getStock(item);
        this.$emit('addToCart', item);
      },
      hasStock(item) {
        var ret = false;
        if (item.hasOwnProperty('pqn')) {
          ret = item.pqn;
        }
        return ret;
      }
    }
  }
</script>

<style lang="scss" scoped>
  img {
    cursor: pointer;
  }

  .grid-view-item {
    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

      .grid-view-img {
        opacity: 0.9;
      }
    }
  }
</style>
